import script from "./withdraw-record.vue?vue&type=script&setup=true&lang=js"
export * from "./withdraw-record.vue?vue&type=script&setup=true&lang=js"

import "./withdraw-record.vue?vue&type=style&index=0&id=7d5bacb2&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5bacb2"]])

export default __exports__